import { render, staticRenderFns } from "./TikTokTable.vue?vue&type=template&id=59f40709"
import script from "./TikTokTable.vue?vue&type=script&lang=js"
export * from "./TikTokTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports